export default {
  namespaced: true,

  state() {
    return {
      slackAuth: {},
    };
  },

  getters: {
    slackScopeMissing: (state) => (scope, contextName) => {
      const context = state.slackAuth[contextName || 'base'];
      return context?.scopes?.includes(scope) || false;
    },
  },

  actions: {
    openPermissionsModal({ state, rootState, commit }, {
     contextName, missingScope, source, description, dismissable = true, previousModalOnCancel,
    }) {
      const context = state.slackAuth[contextName || 'base'];
      if (!(context?.path && context?.scopes?.length)) return;

      const primaryMissingScope = missingScope || context.scopes[0];
      const modalArgs = {
        visible: true,
        subcomponent: 'the-permissions-modal',
        size: 'lg',
        dismissable,
        data: {
          missingScope: primaryMissingScope,
          redirectUrl: context.path,
          trackingProperties: { source },
          showCancel: dismissable,
          description,
        },
      };
      if (previousModalOnCancel) {
        modalArgs.cancelMutation = 'updateModal';
        modalArgs.cancelArgs = { ...rootState.modal };
      }
      commit('updateModal', modalArgs, { root: true });
    },
  },
};
